import * as actionTypes from 'src/actions';

const initialState = {
  status: 'idle',
  loggedIn: false,
  organization: null,
  cart: [],
  user: {
    role: 'guest',
  },
  card: {}
};

const sessionReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SESSION_LOGIN: {
      return {
        ...state,
        status: 'ready',
        loggedIn: true,
        user: action.payload,
      };
    }
    case actionTypes.SESSION_LOGIN_ATTEMPT: {
      return { ...state, status: 'fetching' };
    }
    case actionTypes.SESSION_ORGANIZATION_RESOLVED: {
      return { ...state, organization: action.payload };
    }
    case actionTypes.SESSION_SET_CARD: {
      return { ...state, card: action.payload };
    }

    case actionTypes.SESSION_LOGOUT: {
      return {
        ...state,
        loggedIn: false,
        status: 'ready',
        user: {
          role: 'guest',
        },
      };
    }

    case actionTypes.SESSION_ADD_TO_CART: {
      const indexInCart = state.cart.findIndex(cartItem =>
        cartItem.item.id == action.payload.item.id);
      if (indexInCart != -1) {
        state.cart[indexInCart].count += 1;
      } else {
        state.cart.push({item: action.payload.item, count:1});
      }
      return { ...state, cart: [...state.cart] };
    }

    case actionTypes.SESSION_UPDATE_CART: {
      const indexInCart = state.cart.findIndex(cartItem =>
        cartItem.item.id == action.payload.item.id);
      if (indexInCart != -1) {
        state.cart[indexInCart].count = action.payload.count;
      }
      return { ...state, cart: [...state.cart] };
    }

    case actionTypes.SESSION_REMOVE_FROM_CART: {
      const indexInCart = state.cart.findIndex(cartItem =>
        cartItem.item.id == action.payload.item.id);
      if (indexInCart != -1) {
        state.cart.splice(indexInCart, 1);
      }
      return { ...state, cart: [...state.cart] };
    }

    default: {
      return state;
    }
  }
};

export default sessionReducer;
